import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=e21b6112&"
import script from "./Programs.vue?vue&type=script&lang=js&"
export * from "./Programs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e21b6112')) {
      api.createRecord('e21b6112', component.options)
    } else {
      api.reload('e21b6112', component.options)
    }
    module.hot.accept("./Programs.vue?vue&type=template&id=e21b6112&", function () {
      api.rerender('e21b6112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/Programs.vue"
export default component.exports